import React from 'react';
import gql from 'graphql-tag';
import { API, graphqlOperation } from 'aws-amplify';
import { GetGiidePaddleAccountDetailsQuery } from '../../graphql/api';
import { useDispatch, useSelector } from 'react-redux';
import { setPaddleAccountDetails } from '../../actions';
import { IState, PaddleAccountDetails } from '../../graphql/types';

const getGiidePaddleAccountDetails = gql`
  query getGiidePaddleAccountDetails($subscriptionId: Int!) {
    getGiidePaddleAccountDetails(subscriptionId: $subscriptionId) {
      errorMessage
      subscriptionId
      planId
      planName
      userId
      email
      marketingConsent
      updateUrl
      cancelUrl
      subscriptionState
      signupDate
      lastPaymentAmount
      lastPaymentCurrency
      lastPaymentDate
      paymentMethod
      cardType
      lastFourDigits
      expiryDate
      nextPaymentAmount
      nextPaymentCurrency
      nextPaymentDate
    }
  }
`;

const usePaddleAccountDetails = (subscriptionId?: number | null) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<boolean>(false);

  const data = useSelector<IState, PaddleAccountDetails | undefined>(
    state => state.paddleAccountDetails
  );

  const refetch = React.useCallback(() => {
    let isMounted = true;
    setLoading(true);

    if (!subscriptionId) {
      setLoading(false);
      return;
    }

    (
      API.graphql(
        graphqlOperation(getGiidePaddleAccountDetails, { subscriptionId })
      ) as Promise<{
        data: GetGiidePaddleAccountDetailsQuery;
      }>
    )
      .then(result => {
        if (isMounted) {
          dispatch(
            setPaddleAccountDetails(result.data.getGiidePaddleAccountDetails)
          );
        }
      })
      .catch(err => {
        if (isMounted) {
          setError(true);
        }
      })
      .finally(() => setLoading(false));

    return () => {
      isMounted = false;
    };
  }, [subscriptionId, dispatch]);

  React.useEffect(() => {
    if (!data) refetch();
  }, [data, refetch]);

  return { data, refetch, loading, error };
};

export default usePaddleAccountDetails;
